import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/testing/${ view }.vue`);
}


const Index = loadView( 'Index' );
const TestView = loadView( 'View' );
const SettingsEdit = loadView( 'settings/Edit' );
const SettingsIndex = loadView( 'settings/Index' );

const testingRoutes = [
    {
        path: 'testing',
        name: 'api.testing.getList',
        component: Index,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'testing/:id',
        name: 'api.testing.get',
        component: TestView,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'testing/settings/testingTypes',
        name: 'api.testing.settings.testingTypes',
        component: SettingsIndex,
        meta: {
            middleware: permission
        }
    },
    {
        path: 'testing/types/:id/settings',
        name: 'api.testing.settings.addTestingTypeSettings',
        component: SettingsEdit,
        meta: {
            middleware: permission
        }
    },
];
export default testingRoutes;
